import React from 'react';
import { AppBar, Toolbar, Box, Typography } from '@mui/material';
import LanguageSwitcher from './LanguageSwitcher';
import { mediaUrl } from '../utils/media';
import { headerColor, readableText } from '../utils/salonTheme';

// Брендована шапка публічної сторінки салону: лого/назва в кольорах салону +
// перемикач мови. Замінює платформний AppBar на /w/:slug сторінках.
export default function SalonHeader({ theme = {}, name = '', onLogoClick }) {
  const bg = headerColor(theme);
  const fg = readableText(bg);
  return (
    <AppBar position="static" elevation={0} sx={{ bgcolor: bg, color: fg }}>
      <Toolbar sx={{ gap: 1 }}>
        <Box
          onClick={onLogoClick}
          sx={{
            display: 'flex', alignItems: 'center', gap: 1.5, flexGrow: 1, minWidth: 0,
            cursor: onLogoClick ? 'pointer' : 'default',
          }}
        >
          {theme.logoUrl && (
            <Box
              component="img"
              src={mediaUrl(theme.logoUrl)}
              alt={name}
              sx={{ height: 40, maxWidth: 160, objectFit: 'contain' }}
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          )}
          {name && (
            <Typography variant="h6" noWrap sx={{ fontWeight: 700, letterSpacing: 0.2 }}>
              {name}
            </Typography>
          )}
        </Box>
        <LanguageSwitcher />
      </Toolbar>
    </AppBar>
  );
}
